<template>
  <payment-result-success-layout
    :title="title"
    :subtitle="subtitle"
    :icon="icon"
    :icon-color="iconColor"
    footer-path="message.billing_payment_paid"
  >
    <template #footer-content>
      <span>
        <span class="font-weight-medium">{{ $t('title.settings') }}</span> →
        <span class="font-weight-medium">{{ $t('title.account') }}</span>  →
        <span class="font-weight-medium">{{ $t('title.billing') }}</span>
      </span>
    </template>
  </payment-result-success-layout>
</template>

<script setup lang="ts">

import {
  PropType, computed,
} from 'vue';
import { InvoiceInfo } from '@/services/billing-utils';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';

const props = defineProps({
  invoiceInfo: { type: Object as PropType<InvoiceInfo>, required: true },
});

const invoiceState = computed(() => {
  if (props.invoiceInfo.processing) return { processing: true };
  if (props.invoiceInfo.open) return { open: true };
  if (props.invoiceInfo.paid) return { paid: true };
  return { error: true };
});

const title = computed(() => {
  if (invoiceState.value.paid) { return i18n.t('label.thank_you'); }
  if (invoiceState.value.processing) { return i18n.t('label.payment_processing'); }
  if (invoiceState.value.open) { return i18n.t('label.oops'); }
  return i18n.t('label.oops');
});

const subtitle = computed(() => {
  if (invoiceState.value.paid) { return i18n.t('message.invoice_paid_success'); }
  if (invoiceState.value.processing) { return i18n.t('message.payment_processing'); }
  if (invoiceState.value.open) { return i18n.t('error.payment_invoice_not_closed_pay_invoice'); }
  return i18n.t('error.billing_general');
});

const icon = computed(() => {
  if (invoiceState.value.paid) { return 'mdi-checkbox-marked-circle'; }
  if (invoiceState.value.processing) { return 'mdi-alert'; }
  if (invoiceState.value.open) { return 'mdi-alert'; }
  return 'mdi-alert';
});

const iconColor = computed(() => {
  if (invoiceState.value.paid) { return 'success'; }
  if (invoiceState.value.processing) { return 'warning'; }
  if (invoiceState.value.open) { return 'error'; }
  return 'error';
});

</script>
